module.exports = __webpack_public_path__ + "static/media/antigua-historic-17.f18fa334.jpg";